import { isRouteErrorResponse } from 'react-router-dom';

const messageOf = (error: unknown): string => {
    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;
    if (isRouteErrorResponse(error)) {
        const data = typeof error.data === 'string' ? error.data : '';
        return [String(error.status), error.statusText, data].filter(Boolean).join(' ');
    }
    try {
        return JSON.stringify(error);
    } catch {
        return String(error);
    }
};

const stackOf = (error: unknown): string => (error instanceof Error ? error.stack || '' : '');

/** Текст для буфера: адреса, час, браузер, повідомлення і стек. */
export const formatAppError = (error: unknown): string => {
    const stack = stackOf(error);
    return [
        `URL: ${window.location.href}`,
        `Time: ${new Date().toISOString()}`,
        `Browser: ${navigator.userAgent}`,
        `Message: ${messageOf(error)}`,
        stack ? `Stack:\n${stack}` : '',
    ]
        .filter(Boolean)
        .join('\n');
};
